import { useFormikContext } from "formik";
import React, { FC } from 'react';
import { TranslationKeys } from '../../../../contexts/TranslationKeys';
import { useLocale } from '../../../../contexts/localeContext';
import { getCommandTitle } from "../commandUtil";
import { Button } from '../../../../components/button/Button';

interface Props {
    onBack: (event: any) => void;
}

const SummaryStep: FC<Props> = ({ onBack }) => {
    const { values } = useFormikContext<any>();
    const { translate } = useLocale();

    return (
        <div className="pt-3 px-5 h-full relative">
            <div className="mb-3 text-portal-blue-primary-shade2 text-xl font-semibold">{translate.byKey(TranslationKeys.summary)}</div>
            <div>
                <div className="flex items-center border-b h-12 text-sm">
                    <span className="text-gray-600 w-32 font-medium">{translate.byKey(TranslationKeys.widgetType)} :</span>
                    <span id="widgetTypeText">{translate.byKey(TranslationKeys.Commands)}</span>
                </div>
                <div className="flex items-center border-b h-12 text-sm">
                    <span className="text-gray-600 w-32 font-medium"> {translate.byKey(TranslationKeys.type)} :</span>
                    <span id="typeSelectedText">{`${getCommandTitle(values.filterBy, translate)}`}</span>
                </div>
                <div className="flex items-center border-b h-12 text-sm">
                    <span className="text-gray-600 w-32 font-medium">{`${getCommandTitle(values.filterBy, translate)}`} :</span>
                    <span id="optionSelectedText">{values.configurationName}</span>
                </div>
            </div>
            <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
                <div className="flex flex-row mt-4">
                    <button
                        className="secondary secondary-inverse py-1 px-5 "
                        type="button"
                        id="backButton"
                        onClick={onBack}>{translate.byKey(TranslationKeys.back)}</button>
                </div>
                <div className="flex flex-row justify-end mt-4 pl-3">
                <Button
                        variant="submit"
                        shape="pill"
                        type="submit"
                        id="confirmButton"
                    >{translate.byKey(TranslationKeys.confirm)}</Button>
                </div>
            </div>
        </div>
    )
}

export default SummaryStep;